import Service, { IService } from "@/model/Service/Service"
import hasCrossPriceByAge, { IHasCrossPriceByAge } from "@/model/mixins/Price/hasCrossPriceByAge"
import hasTotalPriceByTravellerOrAccomodationId, { IHasTotalPriceByTravellerOrAccomodationId } from "@/model/mixins/Price/hasTotalPriceByTravellerOrAccomodationId"
import hasTravellersEligible, { IHasTravellersEligible } from "@/model/mixins/Traveller/hasTravellersEligible"
import hasTravellersIncluded, { IHasTravellersIncluded } from "@/model/mixins/Traveller/hasTravellersIncluded"
import hasTravellersSelected, { IHasTravellersSelected } from "@/model/mixins/Traveller/hasTravellersSelected"
import hasQuoteTravellers, { IHasQuoteTravellers } from "@/model/mixins/hasQuoteTravellers"

class ParticipantServiceBase extends Service {
    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
    }

    getSelectedQuantity(): number {
        return (this as unknown as IHasTravellersSelected).getTravellersSelected().length
    }

}

export interface IParticipantService extends ParticipantServiceBase, IService, IHasTravellersEligible, IHasTravellersSelected, IHasTravellersIncluded, IHasCrossPriceByAge, IHasTotalPriceByTravellerOrAccomodationId, IHasQuoteTravellers {
}

// apply mixins
const ParticipantService: Constructor<IParticipantService> = hasTravellersIncluded(hasQuoteTravellers(hasTravellersSelected(hasTravellersEligible(hasTotalPriceByTravellerOrAccomodationId(hasCrossPriceByAge(ParticipantServiceBase))))))


export default ParticipantService